import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueCurrencyFilter from "vue-currency-filter";

Vue.config.productionTip = false;

Vue.use(VueCurrencyFilter, {
  symbol: "R$",
  thousandsSeparator: ".",
  fractionCount: 2,
  fractionSeparator: ",",
  symbolPosition: "front",
  symbolSpacing: true,
});

Vue.filter('truncate', function (text, length, suffix) {
  if (text.length > length) {
      return text.substring(0, length) + (length < text.length ? suffix || '...' : '');
  } else {
      return text;
  }
});

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
